/**
 * @Author: DJ
 * @Date:   2021-09-06 13:43:26
 * @Last Modified by:   DJ
 * @Last Modified time: 2021-09-09 13:36:05
 */
import React from 'react';
import { XPagination } from '@/components/xqxc_ui';
import { message, Table } from 'antd';
import moment from 'moment';
import PropTypes from 'prop-types';
import { isPlat } from '@/assets/js/authType';
import { tooltipStyle, tooltip, cellWidth, priceFenToYuanCell } from '@/components/TableCell';
import styles from './TableList.module.scss';
import { MainTableFields as tf } from '../../types';

class TableList extends React.Component {

    _takeColumns = () => ([
        {
            title: '企业名称',
            dataIndex: 'targetName',
            key: 'targetName',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '对账周期',
            dataIndex: 'recTime',
            key: 'recTime',
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: (text, record) => {
                return <p>
                    <span>{record.startTime ? moment(record.startTime).format('YYYY-MM-DD') : '' }</span>~
                <span>{record.endTime ? moment(record.endTime).format('YYYY-MM-DD') : ''}</span></p>
            }
        },
        {
            title: '对账金额（元）',
            dataIndex: 'settleAmount',
            key: 'settleAmount',
            width: cellWidth.normal,
            align: 'center',
            render: priceFenToYuanCell
        },
        {
            title: '状态',
            dataIndex: 'verifyStatusName',
            key: 'verifyStatusName',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '生成时间',
            dataIndex: 'gmtCreate',
            key: 'gmtCreate',
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            dataIndex: 'action',
            key: 'action',
            align: 'center',
            width: cellWidth.normal,
            render: (text, record) => this._renderActionCell(record.id, record)
        }
    ]);

    _renderActionCell = (key, record) => {
        const { tableAction } = this.props;
        return (
            <div className={styles.action}>
                <div className={styles.item} onClick={() => tableAction(key, 'detail')}>详情</div>
                <div className={styles.item} onClick={() => {
                    if(record.url){
                        tableAction(record.url, 'export');
                    }else{
                        message.warning('暂无数据');
                    }
                }}>导出对账单</div>
                <div className={styles.item} onClick={() => tableAction(key, 'delete')}>删除</div>
                {/* { isPlat() ? record.verifyStatus == 'CONFIRM_SUCCESS' && <div className={styles.item} onClick={() => tableAction(key, 'pay')}>手工打款</div> :
                record.verifyStatus == 'TO_CONFIRM' && <div className={styles.item} onClick={() => tableAction(key, 'sureAccount')}>确认对账单</div>} */}
            </div>
        );
    }

    render() {
        const { paginationChange } = this.props;
        const { pageNum, pageSize, resultTotal, dataList } = this.props.renderData;
        return (
            <div className={styles.tableContainer}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    rowKey={(record, index) => record.id}
                    columns={this._takeColumns()}
                    dataSource={dataList}
                    pagination={false}
                    scroll={{ y: true }}
                />
                <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                />
            </div>
        );
    }
}

TableList.propTypes = {
    renderData: PropTypes.object.isRequired, // 表格数据源
    tableAction: PropTypes.func.isRequired, // 表格操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
    actionHandle: PropTypes.func,
};

export default TableList;